import { render, staticRenderFns } from "./TransactionsHistory.vue?vue&type=template&id=1e1c213c&scoped=true"
import script from "./TransactionsHistory.vue?vue&type=script&lang=js"
export * from "./TransactionsHistory.vue?vue&type=script&lang=js"
import style0 from "./TransactionsHistory.vue?vue&type=style&index=0&id=1e1c213c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1c213c",
  null
  
)

export default component.exports